<template>
  <div v-if="isAdmin">
    <h5 class="c5">Character Counts</h5>
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th>Ruleset</th>
          <th class="text-center">Characters</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="report in characterCountByRuleset"
          :key="`${report._id}`"
          class="row-click"
        >
          <td>{{report._id}}</td>
          <td class="text-center">{{report.count}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "character-count-by-ruleset",
  data() {
    return {
      characterCountByRuleset: []
    };
  },
  watch: {
    $route: "getData"
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters(["isAdmin"])
  },
  methods: {
    ...mapActions({
      reportCharacterCountByRuleset: "reports/characterCountByRuleset"
    }),
    async getData() {
      try {
        let res = await this.reportCharacterCountByRuleset();
        this.characterCountByRuleset = res.data;
        this.$embers.pageData("Reports");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
